import { Loading } from '@startlibs/components';
import { isMobile, getColor, media } from '@startlibs/utils';
import React, { useRef, useState } from 'react';
import styled, {css} from 'styled-components'
import { IfLocale } from '../../../hocs/IfLocale';
import {AuditRow} from './AuditRow'

const AuditLogTable = styled.div`
  width: 100%;
  color: ${getColor('gray60')};
  background: white;
  border: 1px solid rgba(0,0,0,0.15);
  border-spacing: 0;
  border-radius: 5px;
  position: relative;
  .mobile-row {
    display: contents;
  }
  ${props => props.isLoading && `
    pointer-events: none;
    ${AuditLogTableRow} {
      border-color: transparent;
      > * {
        opacity: 0.1;
        transition: 0.5s ease;
      }
    }
  `}
  ${media.between(810,1024)`
    overflow-x: scroll;
    ::-webkit-scrollbar {
        -webkit-appearance: none;
        height: 7px;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0,0,0,.5);
        -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
    }
  `}
  ${media.max(810)`
    border: 0;
    .mobile-row {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 0.5rem;
    }

    .mobile-row > div {
      flex: 1 1 45%;
    }

    .order-number,
    .mrn {
      text-align: right;
      align-items: flex-end;
    }
  `}
`

export const AuditLogTableRow = styled.div`
  min-height: 2rem;
  position: relative;
  border-bottom: 1px solid rgb(225,225,225);
  display: flex;
  background: white;
  flex-grow: 1;
  width: 100%;
  ${media.between(810,1024)`
    min-width: 702px;
  `}
  ${media.min(810)`
    :nth-child(even) {
      background: ${getColor('backgroundRowColor')};
    }
    :last-child {
      border: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  `}
  ${media.max(810)`
    display: block;
    margin-bottom: 0.75rem;
    background-color: white;
    border-radius: 5px;
    border: 1px solid rgba(0,0,0,0.15);
    padding: 1.5rem;
    position: relative;
  `}
`
export const AuditLogTableHead = styled(AuditLogTableRow)`
  align-items: center;
  font-weight: 600;
  background: white;
  top: 5.5rem;
  position: sticky;
  z-index: 15;
  border-top-left-radius:5px;
  border-top-right-radius:5px;
  border-color: rgba(0,0,0,0.15) !important;
  min-width: 702px;
  ${media.max(1024)`
    position: static;
  `}
  ${media.max(810)`
    display: none;
  `}
`
// const intl = useIntl()
// const label = intl.formatMessage({defaultMessage:"Case ID", description:'audit/Table caseid header css'})
export const AuditLogTableColumn = styled.div`
  flex-basis: 0;
  padding: 0.75rem 0.75rem;
  :first-child {
    padding-left: 1rem;
  }
  :last-child {
    padding-right: 1rem;
  }
  .not-case {
    color: ${getColor('gray150')};
  }
  &.date {
      flex-grow: 0;
      min-width: 140px;
      .time {
        color: ${getColor('gray150')};
      }
  }
  &.event {
    flex-grow: 1;
    max-width: 340px;
    min-width: 260px;
    .id {
      color: ${getColor('gray150')};
    }
    .link {
      user-select: none;
      font-size: 12px;
    }
  }
  &.order-number {
    flex-grow: 2;
    max-width: 110px;
    min-width: 80px;
  }
  &.mrn {
    flex-grow: 2;
    max-width: 110px;
    min-width: 80px;
  }
  &.case-id {
    flex-grow: 2;
    max-width: 120px;
    min-width: 70px;
  }
  &.case-id-legal{
    flex-grow: 2;
    max-width: 120px;
    min-width: 70px;
  }
  &.case-patient {
    flex-grow: 1;
    min-width: 140px;
    max-width: 180px;
  }
  &.case-patient-legal {
    flex-grow: 1;
    min-width: 140px;
    max-width: 180px;
  }
  &.user {
    flex-grow: 1;
    max-width: 250px;
    min-width: 150px;
  }
  ${media.max(810)`
    :first-child {
      padding-left: 0rem;
    }
    :last-child {
      padding-right: 0rem;
    }
    padding: 0;
    :before {
      font-weight: 600;
      display: block;
    }
    &.date {
      position: absolute;
      top: 1.5rem;
      right: 1.5rem;
      border-radius: 5px;
      background-color: rgba(0,0,0,0.05);
      padding: .25rem .5rem;
      text-align: right;
      min-width: auto;
      max-width: 125px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      :before {
        content: "Date / time: ";
        flex-basis: 100%;
      }
      .time {
         margin-left: .25rem;
      }
    }
    &.event {
      margin-bottom: 0.5rem;
      font-size: 16px;
      padding-right: 125px;
      width: 100%;
      max-width: 100%;
      :before {
        content: "Event: ";
        font-size: 13px;
      }
      .id {
        font-size: 13px;
      }
    }
    &.order-number {
      margin-bottom: 0.5rem;
      width: auto;
      float: left;
      :before {
        content: "Order number: ";
      }
    }
    &.mrn {
      margin-bottom: 0.5rem;
      width: auto;
      float: left;
      :before {
        content: "MRN: ";
      }
    }
    &.case-id {
      margin-bottom: 0.5rem;
      width: auto;
      float: left;
      :before {
        content: "Case ID: ";
      }
    }
    &.case-id-legal{
      margin-bottom: 0.5rem;
      width: auto;
      float: left;
      :before {
        content: "ID: ";
      }
    }
    &.case-patient {
      width: auto;
      float: left;
      margin-bottom: .5rem;
      min-width: 140px;
      max-width: 140px;
      margin-right: .5rem;
      :before {
        content: "Patient: ";
      }
    }
    &.case-patient-legal {
      width: auto;
      float: left;
      margin-bottom: .5rem;
      min-width: 140px;
      max-width: 140px;
      margin-right: .5rem;
      :before {
        content: "Client: ";
      }
    }
    &.user {
      width: auto;
      max-width: 100%;
      :before {
        content: "Performed by user: ";
      }
      :after {
        content: "";
        clear: both;
        display: table;
      }
    }
  `}
`

export const DetailContainer = styled.div `
  border: 1px solid rgba(0,0,0,0.025);
  background: rgba(0,0,0,0.05);
  padding: 0.25rem 0.5rem;
  border-radius: 5px;
  margin-top: 0.5rem;
  margin-right: 0.5rem;
  color: rgba(0,0,0,0.7);
  display: inline-block;
  font-size: 12px;
`

const LoadingTableContent = styled.div`
  position: absolute;
  top: 4rem;
  left: 0;
  right: 0;
  height: 100%;
  height: calc(100% - 4rem);
  max-height: 80vh;
  max-height: calc(80vh - 4rem);
  ${props => !props.isMobile && css`
    ${media.desktop`
      max-width: calc(100vw - 5rem - 15px);
      left: 2.5rem;
    `}
    ${media.mobile`
      max-width: calc(100vw - 15px);
      left: 0;
    `}
  `}
`

const EmptyStudyList = styled.div`
  background: rgb(240,240,240);
  min-height: 8rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  max-width: calc(100vw);
  position: sticky;
  left: 0
`

export const Table = ({refreshList, list, isLoading}) => {

  const [auditRecords] = useState(list)
  const tableRef = useRef()
  // const intl = useIntl()
  // const label = intl.formatMessage({defaultMessage:"Case ID", description:'audit/Table caseid header css'})


  return <AuditLogTable ref={tableRef} isLoading={isLoading} isMobile={isMobile()}>
    <AuditLogTableHead isMobile={isMobile}>
      <AuditLogTableColumn className="date">Date / time</AuditLogTableColumn>
      <AuditLogTableColumn className="event">Event</AuditLogTableColumn>
      <IfLocale not contains="LEGAL">
        <AuditLogTableColumn className="case-id">Case ID</AuditLogTableColumn>
        <AuditLogTableColumn className="order-number">Order Number</AuditLogTableColumn>
        <AuditLogTableColumn className="case-patient">Patient </AuditLogTableColumn>
        <AuditLogTableColumn className="mrn">MRN</AuditLogTableColumn>
      </IfLocale>
      <IfLocale contains="LEGAL">
        <AuditLogTableColumn className="case-id-legal">ID</AuditLogTableColumn>
        <AuditLogTableColumn className="case-patient-legal">Client</AuditLogTableColumn>
      </IfLocale>
      <AuditLogTableColumn className="user">Performed by user</AuditLogTableColumn>
    </AuditLogTableHead>
    {auditRecords.length ?
      auditRecords.map(record =>
        <AuditRow refreshList={refreshList} isLoading={isLoading}
                  key={record.id}
                  record={record} isMobile={isMobile()}
        />)
      :
      <EmptyStudyList>{!isLoading && 'No entries found'}</EmptyStudyList>
    }
    {isLoading &&
    <LoadingTableContent isMobile={isMobile()}><Loading absolute size={40} borderWidth={6}/></LoadingTableContent>}
  </AuditLogTable>
}


